export enum PHONE_NUMBER_TYPE {
  DIRECT_EXTENSION = 'direct_extension',
  TENANT = 'tenant',
  CALLER_ID = 'caller_id',
  ANY = 'any',
}
